import {
  PlusCircle,
  CalendarPlus,
  Navigation2,
  Calendar as CalendarIcon,
  List,
  FileSpreadsheet,
  RotateCw,
} from 'lucide-react';
import CommonButton from '../../../../components/common-components/button/CommonButton';
import toolbarStyles from '../../../../styles/ToolbarButtons.module.css';
import type { GridToolbarHelpers } from '@inuxe/prime-odata-grid';
import type { IAppointment } from '../../../../models/appointment/AppointmentModel';
import styles from '../Appointments.module.css';

type AppointmentsToolbarProps = {
  viewMode: 'list' | 'calendar';
  onNewAppointment: () => void;
  onAppointmentForHospitalTag: () => void;
  onTodayRoute: () => void;
  onToggleView: () => void;
  onExportExcel?: (helpers: GridToolbarHelpers<IAppointment>) => void;
  onRefreshList?: (helpers: GridToolbarHelpers<IAppointment>) => void;
  onRefreshCalendar?: () => void;
  gridHelpers?: GridToolbarHelpers<IAppointment> | null;
};

const AppointmentsToolbar = ({
  viewMode,
  onNewAppointment,
  onAppointmentForHospitalTag,
  onTodayRoute,
  onToggleView,
  onExportExcel,
  onRefreshList,
  onRefreshCalendar,
  gridHelpers,
}: AppointmentsToolbarProps) => {
  const toolbar = (
    <>
      <CommonButton
        type="primary"
        onClick={onNewAppointment}
        leftIcon={<PlusCircle size={18} strokeWidth={2} />}
        className={toolbarStyles.toolbarBtnAppointment}
      >
        Yeni Randevu
      </CommonButton>
      <CommonButton
        type="outline"
        onClick={onAppointmentForHospitalTag}
        leftIcon={<CalendarPlus size={18} strokeWidth={2} />}
        className={toolbarStyles.toolbarBtnHospitalTag}
      >
        Hastane/Etiket'e Randevu
      </CommonButton>
      <CommonButton
        type="outline"
        onClick={onTodayRoute}
        leftIcon={<Navigation2 size={18} strokeWidth={2} />}
        className={toolbarStyles.toolbarBtnRoute}
      >
        Bugünkü Rota
      </CommonButton>
      <CommonButton
        type="outline"
        onClick={onToggleView}
        leftIcon={
          viewMode === 'list' ? (
            <CalendarIcon size={18} strokeWidth={2} />
          ) : (
            <List size={18} strokeWidth={2} />
          )
        }
        className={toolbarStyles.toolbarBtnViewToggle}
      >
        {viewMode === 'list' ? 'Takvim Görünümü' : 'Liste Görünümü'}
      </CommonButton>
      {viewMode === 'list' && gridHelpers && onExportExcel ? (
        <CommonButton
          type="tertiary"
          onClick={() => onExportExcel(gridHelpers)}
          leftIcon={<FileSpreadsheet size={18} strokeWidth={2} />}
          className={toolbarStyles.toolbarBtnExcel}
        >
          Excel'e Aktar
        </CommonButton>
      ) : null}
      <CommonButton
        type="refresh"
        onClick={() => {
          if (viewMode === 'list' && gridHelpers && onRefreshList) {
            onRefreshList(gridHelpers);
            return;
          }
          onRefreshCalendar?.();
        }}
        leftIcon={<RotateCw size={18} strokeWidth={2} />}
        className={toolbarStyles.toolbarBtnRefresh}
      >
        Yenile
      </CommonButton>
    </>
  );

  if (viewMode === 'list') {
    return toolbar;
  }

  return <div className={styles.toolbarRow}>{toolbar}</div>;
};

export default AppointmentsToolbar;
